<template>
  <div class="vx-card mb-4 w-full">
    <div class="vx-card__collapsible-content">
      <div class="vx-card__body">
        <vs-table :data="allInformationPackage">
          <caption>
            <h4 class="p-2">
              {{ $t("PackageInfo") }}
            </h4>
          </caption>
          <vs-tr v-if="allInformationPackage.billOfLadingNumber">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("billOfLadingNumber") }}
            </vs-th>
            <vs-td class="p-1"
              >{{ allInformationPackage.billOfLadingNumber }}
            </vs-td>
          </vs-tr>
          <vs-tr
            v-if="allInformationPackage.state > 2 && allInformationPackage.cost"
          >
            <vs-th class="p-1" style="width: 40%">
              {{ $t("Cost") }}
            </vs-th>
            <vs-td class="p-1"
              >{{ Number(allInformationPackage.cost).toLocaleString() }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.partyName">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("CustomerName") }}:
            </vs-th>
            <vs-td class="p-1">
              {{ allInformationPackage.partyName }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.recipientInfo">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("RecipientName") }}:
            </vs-th>
            <vs-td class="p-1">
              {{ allInformationPackage.recipientInfo.recipientName }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.recipientInfo">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("PhoneNumberCustomer") }}:
            </vs-th>
            <vs-td class="p-1">
              {{ allInformationPackage.recipientInfo.phoneNumber }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.operatorInfo">
            <vs-th class="p-1 w-1/2" style="width: 40%">
              {{ $t("OperatorName") }}
            </vs-th>
            <vs-td class="p-1"
              >{{ allInformationPackage.operatorInfo.nickName }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.transportInfo">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("TransportName") }}
            </vs-th>
            <vs-td class="p-1">
              {{ allInformationPackage.transportInfo.nickName }}
            </vs-td>
          </vs-tr>
          <vs-tr v-if="allInformationPackage.transportsFleetInfo">
            <vs-th class="p-1" style="width: 40%">
              {{ $t("TransportFleet") }}
            </vs-th>
            <vs-td class="p-1">
              {{ allInformationPackage.transportsFleetInfo.name }}
            </vs-td>
          </vs-tr>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allInformationPackage: {},
  },
};
</script>
